import React from "react";
import "./Homepage.css";

import AccordionDetails, {
  accordionDetailsClasses,
} from "@mui/joy/AccordionDetails";
import AccordionSummary, {
  accordionSummaryClasses,
} from "@mui/joy/AccordionSummary";
import {
  Typography,
  Box,
  Accordion,
  AccordionGroup,
  Stack,
  Button,
} from "@mui/joy";
import PropTypes from "prop-types";

const FrequentlyAskedQuestions = ({ goToResources }) => {
  return (
    <Stack direction={"column"} padding={4} spacing={1}>
      <Stack direction={"column"} spacing={1} sx={{ alignItems: "center" }} className="section-header">
        <Typography level="h1" style={{ textAlign: "center" }}>
          Frequently Asked Questions
        </Typography>
        <Typography level="body-lg" style={{ textAlign: "center" }}>
          Learn how to understand and act on legislation by contacting your
          representatives through an easy to use email template.
        </Typography>
        <Button
          variant="soft"
          onClick={(e) => goToResources(e)}
          sx={{ width: "25%" }}
        >
          Resources
        </Button>
      </Stack>
      <AccordionGroup
        variant="outlined"
        color="neutral"
        transition="0.2s ease"
        size="lg"
        sx={{
          backgroundColor: "white",
          borderRadius: "md",
          [`& .${accordionDetailsClasses.content}.${accordionDetailsClasses.expanded}`]:
            {
              paddingBlock: "1rem",
            },
          [`& .${accordionSummaryClasses.button}`]: {
            paddingBlock: "1rem",
          },
        }}
      >
        <Accordion color="neutral">
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              Where did you get all of this information?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                Congress makes information readily available through
                Congress.gov. You can find information about upcoming bills as
                well as members of congress.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              Why is civic engagement important?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                Civic engagement is crucial because it fosters a sense of
                community and belonging, encourages active participation in
                democracy, and helps ensure that Boxerse voices are heard in
                decision-making processes. It can lead to more responsive
                governance and better representation of various groups,
                particularly those that are often underrepresented.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              What is the purpose of this civic engagement website?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                Civic engagement is crucial because it fosters a sense of
                community and belonging, encourages active participation in
                democracy, and helps ensure that Boxerse voices are heard in
                decision-making processes. It can lead to more responsive
                governance and better representation of various groups,
                particularly those that are often underrepresented.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              How can I navigate the website effectively?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                You can navigate the website using the naviagtion bar at the
                top, which includes sections such as "Bills & Legislation,"
                "Legislators," and "Resources." Bills & Legislation has a large
                list of bills introduced in the current congress. To get more
                detail on any specific bill, just select whichever you are
                interested in and you will be redirected to a detail page that
                will tell you more about how to contact your representative.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              How does the website ensure accessibility for all users?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                We are committed to making this website accessible to everyone.
                We follow web accessibility guidelines to ensure that all
                content is usable for inBoxiduals with disabilities. This
                includes providing alternative text for images, ensuring
                keyboard navigation, and using clear language throughout the
                site.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              How can I stay updated on the different bills and legislation?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                Currently we do not have a mechanism to send alerts to our users
                about bill updates, but it is in the works. For now, you will
                have to bookmark this page on your browser and search for any of
                the latest updates on legislation through our "Bills &
                Legislation" page.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary>
            <Typography
              level="title-lg"
              sx={{ textAlign: "left", width: "100%" }}
            >
              I don't understand the process the bills go through.
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className="history-container" sx={{ padding: 1 }}>
              <Typography level="body-lg">
                Check our our "Resources" page for more information about the
                different types of bills, the process they go through, and other
                important information about Congress.
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </AccordionGroup>
    </Stack>
  );
};

// Prop types for our Component
FrequentlyAskedQuestions.propTypes = {
  goToResources: PropTypes.func.isRequired,
};

export default FrequentlyAskedQuestions;
